module.exports = __webpack_public_path__ + "img/redcross.d18b36a4.svg";